/**
 * @description
 * This function return true if you are in the browser.
 * If this site is rendered on the Server (Gatsby), we will encounter
 * a ReferenceError, because window is not defined
 */
export default typeof window !== 'undefined';
